import { BaseTooltip, FlexRow } from '@/src/components'
import { appColors } from '@/src/theme'
import { Flex, FormControl, FormLabel, type FormLabelProps, Textarea, type TextareaProps } from '@chakra-ui/react'

interface IFormTextareaProps extends TextareaProps {
  name: string
  value?: string
  label?: string
  tooltip?: string
  isInlineLabel?: boolean
  isRequired?: boolean
  labelProps?: FormLabelProps
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
}

export const FormTextarea = ({
  name,
  value,
  label,
  tooltip,
  isInlineLabel,
  isRequired,
  labelProps,
  onChange,
  ...restProps
}: IFormTextareaProps) => {
  return (
    <FormControl isRequired={isRequired}>
      <Flex direction={isInlineLabel ? 'row' : 'column'}>
        {(label || tooltip) && (
          <FlexRow justifyContent='flex-start' marginBottom={2} alignItems={'center'}>
            <FormLabel color={appColors.secondaryForeground} fontSize='14px' marginBottom={0} {...labelProps}>
              {label}
            </FormLabel>
            {tooltip && <BaseTooltip width={'16px'} height={'16px'} label={tooltip} />}
          </FlexRow>
        )}

        <Textarea
          name={name}
          value={value}
          onChange={onChange}
          borderRadius='4px'
          pt='10px'
          resize='none'
          fontSize='14px'
          color='#0D0D0D'
          minW='260px'
          height='98px'
          border='1px solid'
          borderColor='border'
          // _hover={{ borderColor: 'gray.400' }}
          _focus={{ borderColor: 'primary' }}
          _focusVisible={{ borderColor: 'primary', outline: 'none' }}
          {...restProps}
        />
      </Flex>
    </FormControl>
  )
}
